<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.api_keys.create_title')"
  :subtitle="$t('companies.api_keys.create_description')"
  :rightActions="rightActions"
  width="620"
)
  UiFormGroup(
    :label="$t('companies.api_keys.name')"
    :vuelidateModel="v$.api_key.name"
  )
    UiInput(
      v-model="api_key.name"
      :error="v$.api_key.name.$error"
    )
</template>

<script>
import ApiCompanyApis from "@/api/companyApiKeys.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      api_key: {
        name: {
          required: required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      companyId: null,
      api_key: {
        name: null,
      },
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(companyId) {
      this.v$.$reset();
      this.companyId = companyId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
      });
      let params = {
        api_key: {
          ...this.api_key,
        },
      };
      ApiCompanyApis.createApiKey(this.companyId, params)
        .then((res) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {});
    },
  },
};
</script>
